import React from "react";
import useBookingModal from "./hook";
import Modal from "../../../Components/Modal/Modal";
import { getTeacherProfileName, parseTime } from "../../../Helper";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import { Divider } from "semantic-ui-react";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import ConfirmButton from "../../../Components/Buttons/ConfirmButton";
import { StylesBookingModal } from "./styled";
import { Grid, Box } from "@mui/material";
import { permIndices } from "../../../Permissions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const BookingModalLayout = ({
  isOpenBookingModal,
  teacher,
  classNameList,
  radioNonTeaching,
  setRadioNonTeaching,
  handleCloseBooking,
  setRadioOnlineMode,
  setRadioTeachingMode,
  levelOptions,
  radioOnlineMode,
  changeDailyNonTeachingTime,
  changeLevel,
  changeSavedClass,
  getClassName,
  bookingStates,
  level,
  selectCampus,
  changeFromDate,
  changeToDate,
  fromDate,
  toDate,
  dailyNonTeachingTime,
  getCampusName,
  selectClass,
  changeNTTcheck,
  checkNonTeaching,
  getDateRangeDescription,
  radioDeliveryMode,
  setRadioDeliveryMode,
  radioTeachingMode,
  weeklyNonTeachingTime,
  saveDate,
}) => {
  return (
    <StylesBookingModal>
      <Modal
        className="book-teacher-modal"
        onClose={handleCloseBooking}
        show={isOpenBookingModal}
        header={
          <div className="d-flex align-items-center">
            <div className="calendar-avatar-box">
              <img
                alt="teacher_avatar"
                src={teacher.img_url}
                className="calendar-teacher-avatar"
              />
            </div>
            You're booking {getTeacherProfileName(teacher)}
          </div>
        }
      >
        <StylesBookingModal>
          <Divider />
          <p className="text-center mt-2 mb-4 font-bold">Choose a date range</p>
          <Grid spacing={2} container>
            <Grid item xs={6}>
              <FormDatePicker
                label="From"
                id="from_date"
                placeholderText="Select date"
                showYearDropdown
                showMonthDropdown
                popperClassName="some-custom-class"
                showPopperArrow={false}
                dropdownMode="select"
                dateFormatCalendar="MMMM"
                dateFormat="dd-MM-yyyy"
                yearDropdownItemNumber={5}
                scrollableYearDropdown
                onChange={(date) => changeFromDate(date)}
                selected={fromDate || bookingStates?.selected_date}
                // minDate={new Date("2023-01-09")}
                maxDate={toDate}
                // minDate={new Date()}
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                label="To"
                id="to_date"
                placeholderText="Select date"
                showYearDropdown
                showMonthDropdown
                popperClassName="some-custom-class"
                showPopperArrow={false}
                dropdownMode="select"
                dateFormatCalendar="MMMM"
                dateFormat="dd-MM-yyyy"
                yearDropdownItemNumber={10}
                scrollableYearDropdown
                onChange={(date) => changeToDate(date)}
                selected={toDate || bookingStates?.selected_date}
                minDate={fromDate}
                // minDate={
                //   this.state.from_date == null
                //     ? new Date("2023-01-09")
                //     : this.state.from_date
                // }
              />
            </Grid>
            <Grid item xs={6}>
              <FormDropdown
                id="class"
                label="Select From Saved Class"
                // header={<div>{this.state.class_error_message}</div>}
                onChange={changeSavedClass}
                //selected={this.state.level}
                // value={this.state.select_class._id}
                // disabled={this.state.class_error_message}
                required
              >
                <option value="" key="default">
                  Select class
                </option>
                {classNameList?.map((item) => (
                  <option value={item.value}>{item.name}</option>
                ))}
              </FormDropdown>
            </Grid>
            <Grid item xs={6}>
              <div style={{ height: "19px" }} />
              <span>
                Cannot find your saved class or correct level?
                <em className="redirect-link">
                  <Link to="/Timetable"> Update timetable</Link>
                </em>
              </span>
            </Grid>
            <Grid item xs={6}>
              <FormDropdown
                id="level"
                label="Select Level"
                // header={<div>{this.state.class_error_message}</div>}
                onChange={changeLevel}
                // value={this.state.level}
                // disabled={this.state.class_error_message}
                required
              >
                <option value="" key="default">
                  Select class level
                </option>
                {levelOptions.map((lvl, index) => {
                  return (
                    <option value={lvl} key={index}>
                      {getClassName(lvl)}
                    </option>
                  );
                })}
              </FormDropdown>
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={6}>
              <p className="form-label">Delivery mode</p>
              <CheckableButton
                id="delivery-campus"
                name="delivery_mode"
                onChange={() => setRadioDeliveryMode("On campus")}
                checked={radioDeliveryMode === "On campus"}
              >
                On campus
              </CheckableButton>
            </Grid>
            <Grid item xs={6}>
              <div style={{ height: "19.9px" }} />
              <CheckableButton
                id="delivery-online"
                name="delivery_mode"
                onChange={() => setRadioDeliveryMode("Online")}
                checked={radioDeliveryMode === "Online"}
              >
                Online
              </CheckableButton>
            </Grid>
            {radioDeliveryMode === "Online" && (
              <>
                <Grid item xs={6}>
                  <p className="form-label">Online mode</p>
                  <CheckableButton
                    id="online-campus"
                    name="online_mode"
                    onChange={() => setRadioOnlineMode("Deliver on-campus")}
                    checked={radioOnlineMode === "Deliver on-campus"}
                  >
                    Deliver on-campus
                  </CheckableButton>
                </Grid>
                <Grid item xs={6}>
                  <div style={{ height: "19.9px" }} />
                  <CheckableButton
                    id="online-home"
                    name="online_mode"
                    onChange={() => setRadioOnlineMode("Deliver from home")}
                    checked={radioOnlineMode === "Deliver from home"}
                  >
                    Deliver from home
                  </CheckableButton>
                </Grid>
              </>
            )}
          </Grid>
          <Box className="mt-4">
            <Divider />
            {(bookingStates.selected_date || fromDate) &&
              level &&
              selectCampus && (
                <div className="d-flex flex-column mb-3 text-left">
                  <div>
                    You are booking a Teacher for{" "}
                    <b> {getDateRangeDescription()}</b> at{" "}
                    <b> {getCampusName()}</b>.
                    <p>
                      Arrival time <b> {parseTime(selectClass.arrival_time)}</b>{" "}
                      to start class at
                      <b> {parseTime(selectClass.start_time)}</b>. Class ends at{" "}
                      <b>{parseTime(selectClass.end_time)}</b>. Total{" "}
                      <b>{selectClass.paid_teaching_hours}</b> paid hours.
                    </p>
                  </div>
                  <p>
                    Class type/level is <b>{getClassName(level)}</b> and the
                    delivery mode is <b> {radioDeliveryMode}</b>.
                  </p>
                  <br />
                  <p>
                    Add paid non-teaching time below or Confirm to complete
                    booking.
                  </p>
                  <br />
                  <span>
                    <em className="redirect-link">
                      *If these details are not correct, please navigate to your{" "}
                      <Link to="/Timetable">TIMETABLE</Link> or{" "}
                      <Link to="/Campus">CAMPUS</Link> to update your saved
                      records.
                    </em>
                  </span>
                </div>
              )}
            <CheckableButton
              id="non_teaching"
              name="non_teaching"
              checkbox
              className="w-75 mr-3 my-3"
              onChange={changeNTTcheck}
              checked={checkNonTeaching}
            >
              Add paid non-teaching time
            </CheckableButton>
            <Grid
              style={{
                display: checkNonTeaching ? "flex" : "none",
              }}
              spacing={2}
              container
            >
              <Grid item xs={6}>
                <CheckableButton
                  id="teaching_daily_mode"
                  name="teaching_mode"
                  onChange={() => setRadioTeachingMode("Daily")}
                  checked={radioTeachingMode === "Daily"}
                >
                  Daily
                </CheckableButton>
              </Grid>
              <Grid item xs={6}>
                <CheckableButton
                  id="teaching_weekly_mode"
                  name="teaching_mode"
                  onChange={() => setRadioTeachingMode("Weekly")}
                  checked={radioTeachingMode === "Weekly"}
                >
                  Weekly
                </CheckableButton>
              </Grid>
              <Grid
                sx={{
                  display: checkNonTeaching ? "flex" : "none",
                }}
                item
                xs={6}
              >
                <FormDropdown
                  label="Length of paid non-teaching time"
                  id="daily_non_teaching_time"
                  onChange={changeDailyNonTeachingTime}
                  value={
                    radioTeachingMode === "Daily"
                      ? dailyNonTeachingTime
                      : weeklyNonTeachingTime
                  }
                >
                  {radioTeachingMode === "Daily" ? (
                    <>
                      <option value={10}>10 mins</option>
                      <option value={15}>15 mins</option>
                      <option value={20}>20 mins</option>
                      <option value={30}>30 mins</option>
                      <option value={45}>45 mins</option>
                      <option value={1 * 60}>1 hour</option>
                      <option value={2 * 60}>2 hours</option>
                      {selectClass.paid_teaching_hours <= 9 ? (
                      <>
                        <option value={3 * 60}>3 hours</option>
                        <option value={4 * 60}>4 hours</option>
                        <option value={5 * 60}>5 hours</option>
                        <option value={6 * 60}>6 hours</option>
                        <option value={7 * 60}>7 hours</option>
                        <option value={8 * 60}>8 hours</option>
                        <option value={9 * 60}>9 hours</option>
                        <option value={10 * 60}>10 hours</option>
                      </>
                      ) : null}
                    </>
                  ) : (
                    <>
                      <option value={30}>30 mins</option>
                      <option value={45}>45 mins</option>
                      <option value={1 * 60}>1 hour</option>
                      <option value={2 * 60}>2 hours</option>
                      <option value={3 * 60}>3 hours</option>
                      <option value={4 * 60}>4 hours</option>
                      <option value={5 * 60}>5 hours</option>
                      <option value={6 * 60}>6 hours</option>
                      <option value={7 * 60}>7 hours</option>
                      <option value={8 * 60}>8 hours</option>
                      <option value={9 * 60}>9 hours</option>
                      <option value={10 * 60}>10 hours</option>
                    </>
                  )}
                </FormDropdown>
              </Grid>
            </Grid>
            {radioTeachingMode === "Daily" && checkNonTeaching && (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CheckableButton
                    id="non_teaching_before"
                    name="non_teaching"
                    onChange={() => setRadioNonTeaching("Before class")}
                    checked={radioNonTeaching === "Before class"}
                  >
                    Before class
                  </CheckableButton>
                </Grid>
                <Grid item xs={6}>
                  <CheckableButton
                    id="non_teaching_after"
                    name="non_teaching"
                    onChange={() => setRadioNonTeaching("After class")}
                    checked={radioNonTeaching === "After class"}
                  >
                    After class
                  </CheckableButton>
                </Grid>
              </Grid>
            )}
          </Box>
          <ConfirmButton
            type="button"
            onClick={saveDate}
            // disabled={this.state.isCreatingBooking}
          >
            Submit
          </ConfirmButton>
        </StylesBookingModal>
      </Modal>
    </StylesBookingModal>
  );
};

const BookingModal = (props) => {
  return <BookingModalLayout {...useBookingModal(props)} />;
};

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
    classes: state.college.classes,
    viewbookings: state.college.user.permissions
      ? state.college.user.permissions & (1 << permIndices.vi_book)
      : 1,
    editbookings: state.college.user.permissions
      ? state.college.user.permissions & (1 << permIndices.ed_book)
      : 1,
  };
}

export default connect(mapStateToProps)(BookingModal);
